var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.step == 1)?_c('Part1',{on:{"next":function($event){_vm.step++}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }